import { ButtonMui } from 'src/components/ButtonMui'
import { SelectMui } from 'src/components/SelectMui'
import styled from 'styled-components'

export const CustomSelect = styled(SelectMui)`
    width: 19rem !important;
    height: 2.6rem;
    margin: 0 !important
`

export const ActionButton = styled(ButtonMui)`
  width: 23rem;
  height: 2.5rem;
`
